import React from 'react'
import { Form, Button, Segment, Label, List, ListItem, Message, Confirm, Table, Image } from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import {connect} from 'react-redux'
import {getTemplatesAction} from '../../../../../actions/template.action'
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}
class RepeatRulePanel extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      repeatRules: []
    }
  }
  loadRepeatRules () {
    const api = createAPIClient()
    api.get(`/api/repeatrule?template=${this.props.templateId}`)
      .then(result => {
        this.setState({repeatRules: result.data})
      })
      .catch(error => {
        console.log(error)
      })
  }
  deleteRepeatRule (id) {
    const api = createAPIClient()
    api.delete(`/api/repeatrule/${id}`)
      .then(result => {
        this.loadRepeatRules()
      })
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.templateId !== this.props.templateId) {
      this.loadRepeatRules()
    }
  }
  componentDidMount () {
    this.loadRepeatRules()
  }


  render () {
    const tableRows = (
      <Table.Body>
        {this.state.repeatRules.map(rule => {
          return (
            <Table.Row key={rule._id}>
              <Table.Cell>
                <a href='#' onClick={this.deleteRepeatRule.bind(this, rule._id)}>Delete</a>
              </Table.Cell>
              <Table.Cell>{rule.name}</Table.Cell>
              <Table.Cell> {rule.last_run ? new Date(rule.last_run).toLocaleString() : ""} </Table.Cell>
              <Table.Cell>{new Date(rule.next_run).toLocaleString()}</Table.Cell>
              <Table.Cell>{rule.status}</Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )
    const table = (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{width: '50px'}} />
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Last run</Table.HeaderCell>
            <Table.HeaderCell>Next run</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {tableRows}
      </Table>
    )
    if (this.state.repeatRules.length > 0) {
      return (
        <Segment>
          {table}
        </Segment>
      )
    } else {
      return (
        <Segment>
          {'There are no repeat rules'}
        </Segment>
      )
    }

  }
}
function mapStateToProps (state) {
  return {locations: state.account.user.locations, templates: state.templates.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(RepeatRulePanel)




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/repeatrulepanel/index.js